import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';

import {PositiveButton, PositiveButton2} from '../atoms/Buttons/PositiveButton.js';
import {NegativeButton} from '../atoms/Buttons/NegativeButton.js';
import {DangerButton} from '../atoms/Buttons/DangerButton.js';
import BackButton from '../atoms/Buttons/BackButton.js';


export default function FooterButton({components, _props, justifyContent}) {
  if (!components) {
    return <></>;
  }
  const _isMobile = Object.hasOwn(_props, 'isMobile') ? _props.isMobile : false;
  const _direction = _isMobile ? 'column' : 'row';
  const _alignItems = _isMobile ? 'center' : 'flex-start';
  const _btnWidth = _isMobile ? '50vw' : '';
  const _justifyContent = justifyContent ? justifyContent : 'center';
  let _footerBtn = [];
  for (const btn of components) {
    if (btn.hidden == true) continue;
    if (btn.type == 'positive' || btn.type == 'positive2') {
      const _positiveProps = createPositiveProps(btn, _btnWidth);
      _footerBtn.push( <Grid key={'key' + btn.key} item>
        {btn.type == 'positive' ?
        <PositiveButton {..._positiveProps}>
          <span>{btn.label}</span>
        </PositiveButton>:
        <PositiveButton2 {..._positiveProps}>
          <span>{btn.label}</span>
        </PositiveButton2>}
      </Grid>);
    }
    if (btn.type == 'negative') {
      const _negativeProps = createNegativeProps(btn, _btnWidth);
      _footerBtn.push( <Grid key={'key' + btn.key} item>
        <NegativeButton {..._negativeProps}>
          <span>{btn.label}</span>
        </NegativeButton>
      </Grid>);
    }
    if (btn.type == 'danger') {
      const _negativeProps = createDangerProps(_props, btn, _btnWidth);
      _footerBtn.push( <Grid key={'key' + btn.key} item>
        <DangerButton {..._negativeProps}>
          <span>{btn.label}</span>
        </DangerButton>
      </Grid>);
    }
    if (btn.type == 'back') {
      const _backProps = createBackProps(_props, btn, _btnWidth);
      _footerBtn.push(<Grid key={'key' + btn.key} item>
        <BackButton {..._backProps} />
      </Grid>);
    }
  }
  return (<Grid container
    justifyContent={_justifyContent}
    alignItems={_alignItems}
    direction={_direction}
    spacing={1}
  >
    {_footerBtn}
  </Grid>);
}

function createPositiveProps(btn, mobileWidth) {
  const positiveProps = {
    id: 'id' + btn.key,
    onClick: btn.click,
    disabled: btn.disabled,
    variant: 'contained',
    size: btn.size || 'large',
  };
  if (Object.hasOwn(btn, 'startIcon')) {
    positiveProps['startIcon'] = btn.startIcon;
  }
  positiveProps['style'] = btn.style ? btn.style : {};
  if (mobileWidth != '') {
    positiveProps.style.width = mobileWidth;
  }
  return positiveProps;
}

function createNegativeProps(btn, mobileWidth) {
  const negativeProps = {
    id: 'id' + btn.key,
    onClick: btn.click,
    disabled: btn.disabled,
    variant: 'contained',
    size: btn.size || 'large',
  };
  if (Object.hasOwn(btn, 'startIcon')) {
    negativeProps['startIcon'] = btn.startIcon;
  }
  negativeProps['style'] = btn.style ? btn.style : {};
  if (mobileWidth != '') {
    negativeProps.style.width = mobileWidth;
  }
  return negativeProps;
}

function createDangerProps(props, btn, mobileWidth) {
  const closeProps = {
    id: 'id' + btn.key,
    onClick: btn.click,
    disabled: btn.disabled,
    variant: 'contained',
    size: btn.size || 'large',
  };
  if (Object.hasOwn(btn, 'label')) {
    closeProps['label'] = btn.label;
  }
  closeProps['style'] = btn.style ? btn.style : {};
  if (mobileWidth != '') {
    closeProps.style.width = mobileWidth;
  }
  return closeProps;
}

function createBackProps(props, btn, mobileWidth) {
  const backProps = {
    props: props,
    showWarning: btn.showWarning,
    returnPath: btn.returnPath,
    isModified: btn.isModified,
    size: btn.size || 'large',
  };
  if (Object.hasOwn(btn, 'label')) {
    backProps['label'] = btn.label;
  }
  if (Object.hasOwn(btn, 'onCheckGrid')) {
    backProps['onCheckGrid'] = btn.onCheckGrid;
  }
  backProps['style'] = btn.style ? btn.style : {};
  if (mobileWidth != '') {
    backProps.style.width = mobileWidth;
  }
  return backProps;
}

FooterButton.propTypes = {
  components: PropTypes.array,
  _props: PropTypes.object,
  justifyContent: PropTypes.string,
};
